module.exports = __webpack_public_path__ + "img/icon_contact_blue.c33ccfc0.svg";